import React from 'react';

const CompanySICFilterIcon = (props: any) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8 17H3V3H15V7.5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M7 17V12H9.5" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M6.5 6.5H11M6.5 9H10" strokeLinecap="round" strokeWidth="1.5" />
      <path d="M11.6094 12.1528H18.4983" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M11.0391 15.5972H17.928" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M13.6189 10L12.7578 17.75" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M16.7752 10L15.9141 17.75" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </svg>
  );
};

export default CompanySICFilterIcon;
